module.exports = __webpack_public_path__ + "static/media/bgRoof.1b320f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgRoof.png
// module id = 1272
// module chunks = 0